import { SerializedError } from '@reduxjs/toolkit/dist/createAsyncThunk';

import { genericErrorMessage } from './serverErrorFormatter';

export function formatRTKQuerySerializedError(error: SerializedError) {
  return error.message || genericErrorMessage;
}
